import React from "react";
import {
  About,
  FAQ,
  Hero,
  ContactUs,
  OurApproach,
  OurClasses,
  TryBefore,
  EmailDiscount,
  FreeTrialAbout,
  FreeTrialSkills,
  FreeTrialPrograms,
  NewFreeTrialHero,
  NewFreeTrialSkills,
  NewFreeTrialAbout,
  NewWhatWeTeach,
} from "../../components/index";
import { Helmet } from "react-helmet";
import { freetrialhero } from "../../assets/images";
import InstructorExperience from "./InstructorExperience";
import Reviews from "../../components/Home/layout/Reviews";
import ReviewsCompact from "../../components/Home/layout/ReviewsCompact";
import StandaloneTrialForm from "./StandaloneTrialForm";
import styles from "../styles";

const ScholarshipFunnel = () => {
  return (
    <div>
      <Helmet>
        <title>
          Discover Tech Tails: Personalized Tech Education
        </title>
        <meta
          name="description"
          content="Embark on an epic tech learning adventure with Tech Tails. Based in Salt Lake City, Utah, we bring engaging, personalized tech education to your doorstep. Unlock your potential and explore the world of technology with our virtual classes. Join the community of future tech wizards today!"
        />
        <meta
          name="keywords"
          content="Tech Tails, tech education, virtual tech classes, learn technology, Salt Lake City tech, personalized tech learning, tech wizards"
        />
      </Helmet>

      <NewFreeTrialHero
      />
      <InstructorExperience/>
      <FreeTrialSkills />
      <FreeTrialAbout />
      <ReviewsCompact/>
      <FreeTrialPrograms />
      <div
        id="trialClass"
        className="scroll-mt-20 flex flex-col py-8 md:py-10 gap-2 md:px-16 lg:px-32 px-6 items-center bg-gradient-to-br from-darkprimary via-darkprimary to-bluefaded relative overflow-hidden"
      >
        {/* Background decoration */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-pinkprimary rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-orangeprimary rounded-full blur-3xl"></div>
        </div>

        <div className="text-center max-w-4xl mb-4 px-2 md:px-4 relative z-10">
          <h1 className={`${styles.biggerheadingwhite} mb-3 md:mb-4`}>
            Claim Your <span className="relative inline-block">
              Free Trial
              <span className="absolute shadow-sm bottom-[-2px] left-1 w-full h-2 bg-pinkprimary -z-10 -skew-x-[30deg] rounded-sm"></span>
            </span> Class
          </h1>
          
          <p className={`${styles.paragraphwhite} max-w-3xl mx-auto`}>
            See why hundreds of parents trust us! Your child will get a full 45 minute class to 
            experience our teaching style <span className="text-orangeprimary">completely free</span>, with zero obligation.
          </p>
        </div>

        <div className="w-full max-w-3xl relative z-10">
          <StandaloneTrialForm />
        </div>
      </div>
      <EmailDiscount/>
      <FAQ />
    </div>
  );
};

export default ScholarshipFunnel;
